export const SET_ACCOUNT = 'SET_ACCOUNT';
export const GET_ALL = 'GET_ALL';
export const LOAD_INCOME_TABLE = 'LOAD_INCOME_TABLE';

export const LOADING_APPLICATION = 'LOADING_APPLICATION';
export const LOADED_APPLICATION = 'LOADED_APPLICATION';
